import React, { useState } from "react";
import { Outlet, useSearchParams } from "react-router-dom";
import { findDepartment } from "../../../components/v2/DepartmentCache";

export default function AssessmentHome(props) {
    const [searchParams] = useSearchParams();
    const dept = findDepartment(searchParams.get('d'))
    const [departments, setDepartments] = useState([dept])
    return (
        <React.Fragment>
            <div className="py-5">
                <Outlet context={[departments]} />
            </div>
        </React.Fragment>
    )
}
